<section class="mx-auto w-full max-w-3xl">
  <div class="card border border-base-300 bg-base-100 shadow-sm">
    <div class="card-body gap-6">
      <div class="space-y-2">
        <p class="text-sm font-semibold uppercase tracking-[0.2em] text-base-content/50">
          Timbratura
        </p>
        <h1 class="text-3xl font-semibold text-base-content">
          Genera codice QR
        </h1>
        <p class="text-sm text-base-content/70">
          Configura il progetto del tablet e genera il QR code per la timbratura.
        </p>
      </div>

      @if (openingConfiguredQr()) {
        <div class="alert alert-info">
          <span>Apertura QR della sede configurata...</span>
        </div>
      } @else {
        <form [formGroup]="form" (ngSubmit)="onGenerateQr()" class="space-y-5" novalidate>
          @if (totemConfiguration(); as configuration) {
            <div class="alert" [class.alert-info]="projectLockedForCurrentUser()" [class.alert-success]="canChangeProject()">
              <span>
                Tablet configurato su {{ configuration.project_name }} da {{ configuration.configured_by_user_name || 'utente configuratore' }}.
              </span>
            </div>
          }

          @if (projectLockedForCurrentUser()) {
            @if (totemConfiguration(); as configuration) {
              <fieldset class="fieldset">
                <label class="label">Progetto</label>
                <div class="input input-bordered flex h-auto min-h-12 w-full items-center justify-between gap-3 py-3">
                  <span class="font-medium">{{ configuration.project_name }}</span>
                  <span class="text-xs text-base-content/60">ID {{ configuration.project_id }}</span>
                </div>
              </fieldset>
            }
          } @else {
            <fieldset class="fieldset">
              <label class="label" for="project_id">Progetto</label>
              <select
                id="project_id"
                class="select select-bordered w-full"
                formControlName="project_id"
                [disabled]="(loadingProjects() && canChangeProject()) || loadingTotemConfiguration() || generatingQr()"
                (change)="onProjectSelectionChange()"
              >
                <option value="">Seleziona un progetto</option>
                @for (project of projects(); track project.id) {
                  <option [value]="project.id">
                    {{ project.name }}{{ project.code ? ' (' + project.code + ')' : '' }}
                  </option>
                }
              </select>
              @if (form.get('project_id')?.touched && form.get('project_id')?.invalid) {
                <label class="label text-error">Seleziona un progetto prima di continuare.</label>
              }
            </fieldset>

            @if (changingProjectRequiresPassword()) {
              <fieldset class="fieldset">
                <label class="label" for="password">Password utente loggato</label>
                <input
                  id="password"
                  class="input input-bordered w-full"
                  [class.input-error]="form.get('password')?.touched && passwordMissingForProjectChange()"
                  type="password"
                  autocomplete="current-password"
                  formControlName="password"
                  [disabled]="generatingQr()"
                />
                @if (form.get('password')?.touched && passwordMissingForProjectChange()) {
                  <label class="label text-error">Inserisci la password per cambiare sede.</label>
                }
              </fieldset>
            }
          }

          <div class="flex flex-wrap items-center gap-3">
            <button class="btn btn-primary" type="submit" [disabled]="(loadingProjects() && canChangeProject()) || loadingTotemConfiguration() || generatingQr()">
              {{ generatingQr() ? 'Generazione in corso...' : 'Genera codice QR' }}
            </button>
            @if (previousQrAvailable()) {
              <button class="btn btn-outline" type="button" (click)="openPreviousQrViewer()" [disabled]="generatingQr()">
                Torna al QR precedente
              </button>
            }
            @if (loadingTotemConfiguration()) {
              <span class="text-sm text-base-content/70">Caricamento configurazione tablet...</span>
            } @else if (loadingProjects() && canChangeProject()) {
              <span class="text-sm text-base-content/70">Caricamento progetti da Factorial...</span>
            }
          </div>
        </form>

        @if (!loadingProjects() && projects().length === 0 && canChangeProject()) {
          <div class="alert alert-warning">
            <span>Nessun progetto disponibile da Factorial.</span>
          </div>
        }
      }
    </div>
  </div>
</section>

@if (qrViewerOpen()) {
  @if (activeChallenge(); as challenge) {
    <section class="fixed inset-0 z-50 bg-white text-slate-950" #qrViewer>
      <div class="flex h-full flex-col bg-white text-slate-950">
        <div class="flex items-center justify-between border-b border-slate-200 px-6 py-4">
          <div>
            <p class="text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">QR attivo</p>
            <h2 class="text-2xl font-semibold">{{ challenge.project_name }}</h2>
            <p class="text-sm text-slate-600">
              Progetto ID {{ challenge.project_id }} · Emesso alle {{ challenge.issued_at | date: 'HH:mm:ss' }}
            </p>
          </div>

          <div class="flex items-center gap-3">
            <div class="rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold">
              Scade tra {{ secondsRemaining() }}s
            </div>
            <button class="btn btn-outline" type="button" (click)="openBrowserFullscreen(qrViewer)">
              Full screen browser
            </button>
            <button class="btn btn-outline" type="button" (click)="refreshQrCode()" [disabled]="generatingQr()">
              Aggiorna
            </button>
            <button class="btn btn-ghost" type="button" (click)="closeQrViewer()">
              Chiudi
            </button>
          </div>
        </div>

        <div class="flex flex-1 flex-col items-center justify-center gap-8 px-6 py-8">
          <div
            class="flex aspect-square w-full max-w-[72vmin] items-center justify-center rounded-[2rem] border border-slate-200 bg-white p-6 shadow-[0_30px_90px_rgba(15,23,42,0.16)]"
            [innerHTML]="qrSvg()"
          ></div>

          <div class="max-w-2xl text-center">
            <p class="text-lg font-semibold">Mostra questo QR al dipendente per la timbratura.</p>
            <p class="mt-2 text-sm text-slate-600">
              Il contenuto del codice viene rigenerato automaticamente e resta valido solo per pochi secondi.
            </p>
            @if (generatingQr()) {
              <p class="mt-3 text-sm font-semibold text-sky-700">Aggiornamento QR in corso...</p>
            }
          </div>
        </div>
      </div>
    </section>
  }
}
